<template>
    <rkm-overlay>
         <rkm-layout-body title="Atendimento enfermagem">
            <template
                v-if="loaded"
                v-slot:center
            >
                <rkm-button
                    v-if="model.dorToracica"
                    color="warning"
                >
                    Dor torácica
                </rkm-button>

                <rkm-button
                    v-if="model.alergias.length > 0"
                    @click="scrollToAlergias"
                    color="alergia"
                >
                    Paciente alérgico
                </rkm-button>
            </template>

            <template
                v-if="form.paciente"
                v-slot:subtitle
            >

                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="form.paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ form.paciente.nome }} <strong>({{ form.paciente.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ form.paciente.nome }},
                    </span>
                    <span v-if="form.paciente.idade">
                        {{ form.paciente.idade.anos }} anos,
                        {{ form.paciente.idade.meses }} meses
                        e {{ form.paciente.idade.dias }} dias,
                    </span>
                    <span>{{ form.paciente.sexo.descricao }}</span>
                </div>
            </template>

            <template
                v-if="loaded"
                v-slot:actions
            >
                <rkm-dropdown
                    v-if="chamada.telas.length > 1"
                    color="info"
                    title="Chamar paciente"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="volume-up" />
                    </template>

                    <rkm-dropdown-item
                        v-for="tela in chamada.telas"
                        v-bind:key="tela.id"
                        @click="handleChamadaClick(tela)"
                    >
                        {{ tela.nome }}
                    </rkm-dropdown-item>
                </rkm-dropdown>

                <rkm-button
                    v-else-if="chamada.telas.length === 1"
                    @click="handleChamadaClick(chamada.telas[0])"
                    color="info"
                    title="Chamar paciente"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="volume-up" />
                </rkm-button>

                <rkm-button
                    color="danger"
                    @click.stop="exit()"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="handleDesfecho()"
                    color="outline-success"
                    v-if="!form.atendimentoMedico.solicitouReavaliacao"
                >
                    Desfecho
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.handleDesfecho()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content v-if="loaded">
                <Form
                    ref="Form"
                    :plantao-id="$route.params.plantaoId"
                    :data="{ form, model, additionals }"
                    @save="redirectToList()"
                />
            </rkm-layout-content>
        </rkm-layout-body>

        <ModalFinalizarAtendimento
            :plantao-id="$route.params.plantaoId"
            :data="{ form: form, model: model }"
            ref="ModalFinalizarAtendimento"
            @save="redirectToList()"
        />

        <ModalChamada
            :salas="chamada.salas"
            ref="ModalChamada"
        />
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/pronto-atendimento/atendimento-enfermagem/Form'
import ModalFinalizarAtendimento from '@/components/pronto-atendimento/atendimento-enfermagem/components/finalizar-atendimento/Modal'
import ModalChamada from '@/components/pronto-atendimento/fila/components/chamada/Modal'

// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Enums.
import statusExame from '@/enums/pronto-atendimento/statusExame'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

export default {
    components: { Form, ModalFinalizarAtendimento, ModalChamada },
    computed: {
        ...mapGetters({ centroCusto: 'getCentroCusto', getFila: 'getFila' }),
    },
    created() {

        this.setShowExitFormConfirmation()

        this.repositories = {
            atendimentoEnfermagem: this.getConectaSusRepository('prontoAtendimento.enfermagem'),
            fila: this.getConectaSusRepository('prontoAtendimento.fila'),
            chamada: this.getConectaSusRepository('prontoAtendimento.chamada'),
        }

        this.load()
        this.loadChamadaData()
    },
    data: () => ({
        loaded: false,
        form: {},
        model: {},
        additionals: {},
        chamada: { telas: [], salas: [] },
        enums: { statusExame, preferenciaNome, setorTipo }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading', 'setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        load() {

            this.setLoading()

            this.repositories.atendimentoEnfermagem.create(this.$route.params.id)
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadChamadaData() {

            this.repositories.fila.list({
                centro_custo_id: this.centroCusto.id,
                setor_tipo_id: this.enums.setorTipo.ENFERMAGEM,
            })
                .then(({ data }) => {

                    this.chamada.telas = data.form.telas || []
                    this.chamada.salas = data.form.salas || []
                })
                .catch(this.handleError)
        },
        handleChamadaClick(tela) {

            const filaId = this.$route.params.id
            const salaId = this.getFila ? this.getFila.salaId : null

            if (this.chamada.salas.length > 0 && !salaId) {

                this.$refs.ModalChamada.open({ id: filaId }, tela)

                return
            }

            this.repositories.chamada.store({
                fila_id: filaId,
                tela_id: tela.id,
                sala_id: salaId,
            }).catch(this.handleError)
        },
        scrollToAlergias() {

            const element = document.querySelector('#alergias')

            element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        },
        exit() {

            this.showExitConfirmation(async () => {

                this.setLoading()

                return this.repositories.fila.sendBack(this.$route.params.id)
                    .then(() => this.redirectToList())
                    .finally(() => this.unsetLoading())
            }, this.handleError)
        },
        redirectToList() {

            this.unsetShowExitFormConfirmation()

            this.$router.push({ name: 'pronto-atendimento-atendimento-enfermagem-index' }).catch(() => {})
        },
        handleDesfecho() {

            if (this.hasSolicitacaoExameNaoRealizada()) {

                this.showSolicitacaoExamesConfirmation(() => {

                    if (this.hasPrescricaoInternaNaoRealizada()) {

                        this.$nextTick().then(() => {

                            this.showPrescricaoInternaConfirmation(() => {

                                if (this.hasServicoEnfermagemNaoRealizado()) {

                                    this.$nextTick().then(() => {

                                        this.showServicoEnfermagemConfirmation(() => {

                                            this.$refs.ModalFinalizarAtendimento.open()
                                        })
                                    })
                                }
                                else {

                                    this.$refs.ModalFinalizarAtendimento.open()
                                }
                            })
                        })
                    }
                    else if (this.hasServicoEnfermagemNaoRealizado()) {

                        this.$nextTick().then(() => {

                            this.showServicoEnfermagemConfirmation(() => {

                                this.$refs.ModalFinalizarAtendimento.open()
                            })
                        })
                    }
                    else {

                        this.$refs.ModalFinalizarAtendimento.open()
                    }
                })
            }
            else if (this.hasPrescricaoInternaNaoRealizada()) {

                this.showPrescricaoInternaConfirmation(() => {

                    if (this.hasServicoEnfermagemNaoRealizado()) {

                        this.$nextTick().then(() => {

                            this.showServicoEnfermagemConfirmation(() => {

                                this.$refs.ModalFinalizarAtendimento.open()
                            })
                        })
                    }
                    else {

                        this.$refs.ModalFinalizarAtendimento.open()
                    }
                })
            }
            else if (this.hasServicoEnfermagemNaoRealizado()) {

                this.showServicoEnfermagemConfirmation(() => {

                    this.$refs.ModalFinalizarAtendimento.open()
                })
            }
            else {

                this.$refs.ModalFinalizarAtendimento.open()
            }
        },
        showSolicitacaoExamesConfirmation(callback) {

            this.showConfirmation(
                'Há um ou mais exames solicitados. Se continuar com o desfecho, '
                    + 'não será possível realizar o exame. Deseja realmente continuar?',
                async () => callback()
            )
        },
        showPrescricaoInternaConfirmation(callback) {

            this.showConfirmation(
                'Há uma ou mais prescrições interna solicitadas. Se continuar com o desfecho, '
                    + 'não será possível atender a prescrição. Deseja realmente continuar?',
                async () => callback()
            )
        },
        showServicoEnfermagemConfirmation(callback) {

            this.showConfirmation(
                'Há um ou mais serviços de enfermagem solicitados. Se continuar com o desfecho, '
                    + 'não será possível atender ao serviço. Deseja realmente continuar?',
                async () => callback()
            )
        },
        hasSolicitacaoExameNaoRealizada() {

            const status = [this.enums.statusExame.REALIZADO, this.enums.statusExame.NAO_REALIZADO]

            return !!this.form.pedidosExames.concat(this.model.pedidosExames)
                .find(p => p.exames.find(e => !e.status || !status.includes(e.status.id)))
        },
        hasPrescricaoInternaNaoRealizada() {

            const status = [this.enums.statusExame.REALIZADO, this.enums.statusExame.NAO_REALIZADO]

            return !!this.form.prescricoesInterna.concat(this.model.prescricoesInterna).find(p => p.medicamentos
                .find(m => !m.aplicacoes || m.aplicacoes.find(a => !status.includes(a.status.id))))
        },
        hasServicoEnfermagemNaoRealizado() {

            const status = [this.enums.statusExame.REALIZADO, this.enums.statusExame.NAO_REALIZADO]

            return !!this.form.servicosEnfermagem.concat(this.model.servicosEnfermagem)
                .find(s => !status.includes(s.status.id))
        },
    },
    mixins: [error, repository],
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>